import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";

import { TraceabilityDataProvider } from "./contexts/TraceabilityDataContext";

import Header from "./common/header";
import Footer from "./common/footer";
import Slider from "./common/slider";

import Home from "./home";
import Login from "./login";
import DairyFarm from "./dairy-farm";
import MilkGrading from "./milk-grading";
import QualityCheck from "./quality-check";
import Manufacturing from "./manufacturing";
import MeetOurCows from "./meet-our-cows";
import MeetTheFarmers from "./meet-the-farmers";
import SustainabilityInDairyFarm from "./sustanibilty-in-dairy-farm";
import SmartFarming from "./smart-farming";
import OpenHousingFarm from "./open-housing-farm";
import SustainabilityInMilkGrading from "./sustainability-in-milk-grading";
import FarmImprovementServices from "./farm-improvement-services";
import MeetOurCowsTwo from "./meet-our-cows-2";
import FarmersCattle from "./farmers-cattle";
import MeetTheFarmersTwo from "./meet-the-farmers-2";
import CloudConnectivity from "./cloud-connectivity";
import EmpoweringFarmersAndCommunities from "./empowering-farmers-and-communities";
import TechnologyDrivenQualityTests from "./technology-driven-quality-tests";
import Distribution from "./distribution";
import ItsYou from "./it-is-you";
import Faq from "./faq";
import Products from "./products";
import Data from "./data";
import SustainabilityInQualityAssurance from "./sustainability-in-quality-assurance";
import CloudConnectivityQuality from "./cloud-connectivity-quality";
import TechnologyAtWork from "./technology-at-work";
import StringentQualityTesting from "./stringent-quality-testing";
import CertifiedExcellence from "./certified-excellence";
import SmartManufacturing from "./smart-manufacturing";
import QualityAssurance from "./quality-assurance";

import ScrollToTop from "./scrolltopup";
import TechnologyDrivenQualityChecks from "./technology-driven-quality-test-2";

//  Layout wrapper
function Layout({ children }) {
  const location = useLocation();
  const hideLayout = location.pathname === "/login"; // hide on login page

  return (
    <div className="d-flex flex-column min-vh-100">
      {/* Sticky Header & Slider (hide on login) */}
      {!hideLayout && (
        <header className="sticky-top bg-white shadow-sm">
          <Header />
        </header>
      )}

      {/* Main content */}
      <main className="flex-grow-1">
        {!hideLayout && <Slider />}
        {children}
      </main>

      {/* Sticky Footer (hide on login) */}
      {!hideLayout && (
        <footer className="bg-white shadow-sm mt-auto sticky-bottom">
          <Footer />
        </footer>
      )}
    </div>
  );
}

function App() {
  return (
    <TraceabilityDataProvider>
    
      <Router basename={process.env.REACT_APP_BASENAME}> 
         <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Navigate to="/login" />} />
            <Route path="/login" element={<Login />} />
            <Route path="/home" element={<Home />} />
            <Route path="/dairy-farm" element={<DairyFarm />} />
            <Route path="/milk-grading" element={<MilkGrading />} />
            <Route path="/quality-check" element={<QualityCheck />} />
            <Route path="/manufacturing" element={<Manufacturing />} />
            <Route path="/distribution" element={<Distribution />} />
            <Route path="/it-is-you" element={<ItsYou />} />
            <Route path="/sustanibilty-in-dairy-farm" element={<SustainabilityInDairyFarm />} />
            <Route path="/smart-farming" element={<SmartFarming />} />
            <Route path="/open-housing-farm" element={<OpenHousingFarm />} />
            <Route path="/sustainability-in-milk-grading" element={<SustainabilityInMilkGrading />} />
            <Route path="/farm-improvement-services" element={<FarmImprovementServices />} />
            <Route path="/meet-our-cows-2" element={<MeetOurCowsTwo />} />
            <Route path="/farmers-cattle" element={<FarmersCattle />} />
            <Route path="/meet-the-farmers-2" element={<MeetTheFarmersTwo />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/products" element={<Products />} />
            <Route path="/meet-our-cows" element={<MeetOurCows />} />
            <Route path="/meet-the-farmers" element={<MeetTheFarmers />} />
            <Route path="/cloud-connectivity" element={<CloudConnectivity />} />
            <Route path="/empowering-farmers-and-communities" element={<EmpoweringFarmersAndCommunities />} />
            <Route path="/technology-driven-quality-tests" element={<TechnologyDrivenQualityTests />} />
            <Route path ="/sustainability-in-quality-assurance" element={<SustainabilityInQualityAssurance/>}/>
            <Route path="/cloud-connectivity-quality" element={<CloudConnectivityQuality />} />
            <Route path="/technology-at-work" element={<TechnologyAtWork />} />
            <Route path="/stringent-quality-testing" element={<StringentQualityTesting />} />
            <Route path="/data" element={<Data />} />
            <Route path="/certified-for-excellence" element={<CertifiedExcellence />} />
            <Route path="/smart-manufacturing" element={<SmartManufacturing />} />
            <Route path="/quality-assurance" element={<QualityAssurance />} />
            <Route path="/technology-driven-quality-tests-2" element={<TechnologyDrivenQualityChecks />} />
          </Routes>
        </Layout>
      </Router>
    </TraceabilityDataProvider>
  );
}

export default App;
